import { useEffect } from 'react';

import cookieInfo from '@alife/bc-cookie-info';

import ExpressStore from '@/stores/express';
import SkuStore from '@/stores/sku';

import { getTimeZone } from '@/common/getTimeZone';

/**
 * sku 结算区域
 * @returns
 */
interface PropType {
  skuAttrs: SkuTypes.SkuAttr[];
  price: PriceTypes.Root;
  i18n: { [key: string]: string };
  inventory: InventoryTypes.Root;
  skuInfoMap: InventoryTypes.SkuInfoMap;
  // 区分页面和弹窗不同组件入口
  moduleName: string;
  sampleInfo: SampleTypes.Root;
  type: SkuTypes.TypeInfo;
  moq: number;
  renderConfig: DetailTypes.renderConfig<{
    showType: string;
  }>;
  visitCountry: string;
  productId: number;
  productIsMarketGoods: boolean;
  semiHosted?: boolean;
  sourcingTradeAvailable: boolean;
  abtest: DetailTypes.Abtest;
  aliId: number;
  semiLightCustomization: boolean;
  coreCountry: boolean;
}

let TIME_OUT: any = null;

export default function SkuAction(props: PropType) {
  const {
    type = 'product',
    productIsMarketGoods,
    sourcingTradeAvailable,
    productId,
    moq,
    visitCountry, //收货地（shipto）
    semiHosted,
    renderConfig,
    price,
    // 半托管freeshipping物流需要
    aliId,
    // 是否是核心国家，非核心国家没有半托管逻辑
    coreCountry,
  } = props;

  const { productLadderPrices = [] } = price;
  const { showType } = renderConfig;
  const skuStore = SkuStore(state => state);
  const expressStore = ExpressStore(state => state);
  const { dispatchId } = expressStore;
  const skuInfo = skuStore[type];
  if (!skuInfo) return null;

  // 半托管价格
  // https://aone.alibaba-inc.com/v2/project/1075292/req/55296083
  const semiPrice = () => {
    if (type === 'sample') return {};
    if (productLadderPrices.length === 0) return {};
    if (skuInfo.quantity > 0) return {};
    const productList = semiHosted
      ? productLadderPrices[1] || productLadderPrices[0]
      : productLadderPrices[0];
    return {
      productTotalPrice: (productList.promotionPrice || productList.price) * productList.min,
      quantity: productList.min,
    };
  };
  /* 待传入的字段
     * "productId": "1600951190373", 
      "quantity": 4, // sku总数量
      "boxMoq": 12, //按箱moq //detailData.product.boxMoq
      "currentMethod": "SEMI_MANAGED_ECONOMIC@@ECONOMY", // 透穿运力线
      "skuQuantity":"105075543323:1,105075543325:3,",
      "extraParams": "{mode: normal}", // 扩展字段
     */
  // 现货和样品才请求物流
  const fetchExpress = () => {
    if (productIsMarketGoods || sourcingTradeAvailable || type === 'sample') {
      const params: any = {
        productId: productId,
        quantity: (() => {
          if (type === 'sample') {
            return skuInfo.quantity || 1;
          }
          return skuInfo.quantity || moq;
        })(),
        shipToCountry: visitCountry, //收货地
        dispatchCountry: dispatchId, //发货地
        //具体的skuID
        skuQuantity: Object.values(skuInfo.mapInfo)
          .filter(i => i.quantity)
          .reduce((cur, { skuId, quantity }) => ({ ...cur, [`${skuId}`]: quantity }), {}),
        type,
        ...semiPrice(),
        // 以下参数新物流接口不需要，但物流弹窗需要
        productTotalPrice: skuInfo.totalPrice,
        //只有半托管且核心国家才走半托管逻辑，
        forceNoSemiManaged: !(semiHosted && coreCountry),
        extendParam: {
          SEMI_FREE_SHIPPING: {
            isEmptyCart: skuInfo.quantity === 0 ? true : false,
            aliId: aliId,
            sceneCode: 'pc_detail_sku',
            cnaId: cookieInfo.getCNA(), //pc CNA id
            language: cookieInfo.getBuyerLocale(),
            currency: cookieInfo.getBuyerCurrency() || 'USD',
            country: visitCountry, // ship to国家,
            terminal: 'PC',
            timeZone: getTimeZone(cookieInfo.getBuyerLocale()), //当前用户时区
          },
        },
      };

      expressStore.fetch(params, skuInfo.quantity);
    }
  };

  // 切换国家及数量更新物流信息
  useEffect(() => {
    // 初始请求物流组件
    // sku组件，quick view, sku区块，样品
    if (dispatchId) {
      if (
        renderConfig?.isSkuPanel ||
        showType === 'sku' ||
        showType === 'quick' ||
        type === 'sample'
      ) {
        if (skuInfo.quantity > 0) {
          if (TIME_OUT) {
            clearTimeout(TIME_OUT);
            TIME_OUT = null;
          }
          TIME_OUT = setTimeout(() => fetchExpress(), 1 * 200);
        } else {
          fetchExpress();
        }
      }
    }
  }, [dispatchId, skuInfo.quantity]);

  return null;
}
